export const DELIVERY_SETTINGS_FORM_ID = 'deliverySettings';
